export interface ToastOptions {
  durationMs?: number;
  tone?: 'info' | 'warn' | 'danger';
}

const TONE_CLASSES: Record<NonNullable<ToastOptions['tone']>, string> = {
  info: 'bg-text text-white',
  warn: 'bg-warn text-white',
  danger: 'bg-danger text-white',
};

export function toast(message: string, opts: ToastOptions = {}): void {
  if (typeof document === 'undefined') return;
  const tone = opts.tone ?? 'info';
  const duration = opts.durationMs ?? 2500;

  const el = document.createElement('div');
  el.setAttribute('role', 'status');
  el.setAttribute('data-fm-toast', '');
  el.className = [
    'fixed bottom-6 left-1/2 -translate-x-1/2 z-[9999]',
    'px-3 py-2 rounded-md shadow-lg',
    'text-[11.5px] font-semibold font-sans',
    'opacity-0 transition-opacity duration-150',
    TONE_CLASSES[tone],
  ].join(' ');
  el.textContent = message;
  document.body.appendChild(el);
  requestAnimationFrame(() => {
    el.style.opacity = '1';
  });
  window.setTimeout(() => {
    el.style.opacity = '0';
    window.setTimeout(() => {
      el.remove();
    }, 200);
  }, duration);
}
